export default "__VITE_ASSET__v5cbihEb__"